<div [formGroup]="requestForm" *ngIf="requestForm && isBookingIdsReady">
  <p-toast></p-toast>
  <div class="top-container">
    <h3>
      Create new request
    </h3>
    <p-button label="Add Booking" (onClick)="addBookingIdControl()"></p-button>
  </div>
  <div class="table-container">
    <table>
      <tr>
        <td width="200">
          *Booking ID:
        </td>
        <td>
          <div formArrayName="bookingIdArray" class="id-array-container">
            <div *ngFor="let control of bookingIdArray.controls; let i = index" class="booking-id-container">
              <p-dropdown placeholder="--" [filter]="true" filterBy="label" [options]="bookingIds" [formControlName]="i"
                [style]="{'width': '124px'}" (onChange)="onBookingIdChange()"></p-dropdown>
              <p-button (onClick)="deleteBookingIdControl(i)" icon="pi pi-trash"
                styleClass="p-button-danger"></p-button>
            </div>
          </div>
        </td>
      </tr>
      <tr>
        <td>
          Student name
        </td>
        <td class="student-name-container">
          <span>{{studentName}}</span>
        </td>
      </tr>
      <tr>
        <td>
          *Amount
        </td>
        <td>
          <input pInputText formControlName="amount">
          <p *ngIf="requestForm.get('amount')!.errors && requestForm.get('amount')!.errors!['wrongNumberFormat']"
            class="global-warning">Wrong number format</p>
        </td>
      </tr>
      <tr>
        <td>
          Currency
        </td>
        <td>
          <p-dropdown formControlName="currency" [options]="currencies" optionLabel="isoCode"></p-dropdown>
        </td>
      </tr>
      <tr>
        <td>
          *Reason for refund:
        </td>
        <td>
          <textarea pInputTextarea formControlName="reason" class="reason-input"></textarea>
        </td>
      </tr>
      <tr>
        <td>
          Account holder name:
        </td>
        <td>
          <input pInputText type="text" formControlName="accountHolderName">
        </td>
      </tr>
      <tr>
        <td>
          *IBAN:
        </td>
        <td>
          <input pInputText type="text" formControlName="iban">
        </td>
      </tr>
      <tr>
        <td>
          BIC/SWIFT:
        </td>
        <td>
          <input pInputText type="text" formControlName="bic">
        </td>
      </tr>
    </table>
  </div>
  <p-button (onClick)="sendForm()" [disabled]="requestForm.invalid || sendingRequest" label="Submit"></p-button>
</div>